import { render } from "./PersonnalInfo.vue?vue&type=template&id=63ae4244"
import script from "./PersonnalInfo.vue?vue&type=script&lang=js"
export * from "./PersonnalInfo.vue?vue&type=script&lang=js"

import "./PersonnalInfo.vue?vue&type=style&index=0&id=63ae4244&lang=scss"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__